import toast from 'react-hot-toast';
import { ProgramSavedToast } from '../components/ProgramSavedToast';

export const showProgramSavedToast = (
  creatorId: number,
  programName?: string,
) => {
  toast(() => (
    <ProgramSavedToast creatorId={creatorId} programName={programName} />
  ));
};
